<script lang="ts" setup>
  import { ref } from 'vue';
  import { MobileViewLayout } from '../../../../shared/ui/mobile-view-layout';
  import LobbyHeader from './LobbyHeader.vue';
  import RulesModal from './RulesModal.vue';
  import SettingsModal from './SettingsModal.vue';

  const props = defineProps<{ gameCode: number; rounds: number; showRules: boolean }>();
  const slots = defineSlots<{ default(): unknown; settings?(): unknown }>();

  const showRulesModal = ref(props.showRules);
  const showSettingsModal = ref(false);
  const rulesButton = ref<HTMLElement | null>(null);

  const openRules = (button: HTMLElement) => {
    rulesButton.value = button;
    showRulesModal.value = true;
  };
</script>

<template>
  <MobileViewLayout space="m">
    <template #header>
      <LobbyHeader
        :has-settings="!!slots.settings"
        @rules-click="openRules"
        @settings-click="showSettingsModal = true"
      />
    </template>

    <RulesModal
      v-if="showRulesModal"
      :collapse-into="rulesButton"
      :game-code="gameCode"
      @close="showRulesModal = false"
    />

    <SettingsModal v-if="showSettingsModal" @close="showSettingsModal = false">
      <slot name="settings" />
    </SettingsModal>

    <p class="rounds">Rounds: {{ rounds }}</p>
    <slot />
  </MobileViewLayout>
</template>

<style scoped>
  .rounds {
    color: var(--color-text-muted);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-strong);
    margin: 0;
    text-align: center;
  }
</style>
